import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/onboarding',
      search: location.search,
      replace: true,
    });
  },
});
